import React from 'react';
import {
  People,
  Security,
  History,
  MonitorHeart,
} from '@mui/icons-material';

export const MANAGEMENT_TABS = [
  { label: 'Users', path: '/management/users', icon: <People /> },
  { label: 'Roles', path: '/management/roles', icon: <Security /> },
  { label: 'Audit Log', path: '/management/audit', icon: <History /> },
  { label: 'System Status', path: '/system/status', icon: <MonitorHeart /> },
];

export const MANAGEMENT_ACCENT_COLOR = '#10b981';
